import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { TablePage } from "~/components/Table";
import { LogQueryFilters } from "./components/LogQueryFilters";
import {
  LogQuerySearchRequestProvider,
  LogQueryTable,
} from "./components/LogQueryTable";

export function LogQueriesPage() {
  return (
    <TablePage
      title="Search Queries"
      RequestProvider={LogQuerySearchRequestProvider}
      table={
        <>
          <DataStoreBreadcrumbs />
          <LogQueryTable />
        </>
      }
      filters={<LogQueryFilters />}
    />
  );
}
